// Theme Tokens mapped to B2B SaaS Premium Identity
export const theme = {
    // Surfaces
    fondo: '#FFFFFF',
    navbarBg: '#1B1B1B',
    fondoOscuro: '#0F172A', // Slate 900
    tarjetaOscura: '#1E293B', // Slate 800
    blanco: '#FFFFFF',
    gris: '#F8FAFC', // Slate 50 (Fondo secundario / Inputs)
    grisFuerte: '#E2E8F0', // Border subtle (Slate 200)
    inputBg: '#F8FAFC',
    inputBorder: '#CBD5E1', // Slate 300
    
    // Typography
    letra: '#0F172A', // Primary text
    letraClara: '#64748B', // Muted/secondary text
    letraMutedOscura: '#94A3B8', // Text on dark surfaces
    letraBlanca: '#FFFFFF',
    navbarText: '#6D6D6D',
    
    // Brand Colors (Royal Blue Core)
    azulFuerte: '#2563EB', // Primary Brand CTA
    azulHover: '#1D4ED8', // Primary Hover state
    azulFocusRing: 'rgba(37, 99, 235, 0.15)', // Sombra para focus
    
    // Status / Accents
    rojo: '#EF4444',
    verde: '#10B981',
    verdeEmail: '#0D5425',
};

export default theme;